module.exports = __webpack_public_path__ + "static/media/output-onlinepngtools.1355e3f2.png";